import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewaysComponent } from './gateways.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { GatewaysRoutingModule } from './gateways-routing.module';
import { ZoneModule } from '../zone/zone.module';



@NgModule({
  declarations: [GatewaysComponent],
  imports: [
    CommonModule,
    SharedModule,
    GatewaysRoutingModule,
    ZoneModule
  ]
})
export class GatewaysModule { }
